import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import configProvider from "config/configProvider";
import { apiScopes } from "services/apiScopes";
import { reactPlugin } from "config/applicationInsights";
import { Box } from "@mui/material";
import { MaterialUIControllerProvider } from "context";
import MainLayout from "MainLayout";
import AuthApp from "AuthApp";
import { ToastContainer } from "react-toastify";
import AuthProvider from "common/AuthProvider";
import { useLogout } from "azure-integration/hooks";
import { AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import EnvironmentBanner from "common/EnvironmentBanner";

export default function App() {

  const onLogout = useLogout();
  return (
    <>
      <EnvironmentBanner />
      <ToastContainer position="top-right" autoClose={5000} />
      <AuthProvider onLogout={onLogout}>
      <AuthApp
        configProvider={configProvider}
        apiScopes={apiScopes}
        title={configProvider.AppTitle || "Flow"}
        homeUrl={configProvider.HOME_URL}
        contentWidth="100%"
        onAuthenticated={()=>{}}
      >
        <AppInsightsContext.Provider value={reactPlugin}>
          <AppInsightsErrorBoundary
            onError={() => (
              <Box padding="0 1rem">An unhandled error has happened. Please refresh the page and try again.</Box>
            )}
            appInsights={reactPlugin}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MaterialUIControllerProvider>
                <MainLayout />
              </MaterialUIControllerProvider>
            </LocalizationProvider>
          </AppInsightsErrorBoundary>
        </AppInsightsContext.Provider>
      </AuthApp>
      </AuthProvider>
    </>
  );
}
